import { Tabs } from "antd";
import SellerPersonalDetails from "./SellerInformationTabs/SellerPersonalDetails";
import BankDetail from "./SellerInformationTabs/BankDetail";
import CannedMachines from "./SellerInformationTabs/CannedMachines";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
const SellerInformation = () => {
  let { id } = useParams();
  let getItem = localStorage.getItem("currentTab");
  const [defaultIndex, setDefaultIndex] = useState(getItem ? getItem : "1");

  useEffect(() => {
    return () => {
      localStorage.removeItem("currentTab");
    };
  }, []);

  const onTabChange = (key) => {
    setDefaultIndex(key);
  };

  return (
    <>
      <Tabs activeKey={defaultIndex} onChange={onTabChange}>
        <Tabs.TabPane tab={"Personal details"} key={1}>
          <SellerPersonalDetails />
        </Tabs.TabPane>
        {id ? (
          <>
            <Tabs.TabPane tab={"Bank detail"} key={2}>
              {/* <PayoutDetails /> */}
              <BankDetail />
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Canned Machines"} key={3}>
              <CannedMachines />
            </Tabs.TabPane>
          </>
        ) : null}
      </Tabs>
    </>
  );
};
export default SellerInformation;
